module.exports = __webpack_public_path__ + "media/images/cv/503d-8b8ece1b99bb011eab656d88ef6e9247.jpg";